import { DeleteCsvExcelAccountsApi } from "@/features/accounts/csv-excel/services/delete-accounts-api";
import { DeleteCsvExcelAccountsRequestModel } from "@/features/accounts/csv-excel/services/delete-accounts-model";

/// CsvExcel削除処理
export class DeleteCsvExcelAccountsService {
  private deleteCsvExcelAccountsApi = new DeleteCsvExcelAccountsApi();

  /**
   * CsvExcel削除API実行
   */
  public async deleteCsvExcelAccounts(param: DeleteCsvExcelAccountsRequestModel) {
    return await this.deleteCsvExcelAccountsApi.deleteCsvExcelAccounts(param);
  }
}
